import { Pipe, PipeTransform } from '@angular/core';
import { CountriesService } from '../services/countries.service';

@Pipe({
    name: 'provinceName',
    standalone: true
})
export class ProvinceNamePipe implements PipeTransform {

    constructor(private countries: CountriesService) {
    }

    transform(value: unknown, ...args: unknown[]): string {
        if (args[0]) {
            return this.countries.provinceName(args[0], value);
        }
        return '';
    }

}
